// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__263q2","actions":"GroupTable_actions__FVBz7","deleteModalFooter":"GroupTable_deleteModalFooter__3UdQo"};